export default "__VITE_ASSET__XGyPn3s8__"